"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "avellino": {
    "28496185": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "ariano-irpino": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09ffaa95": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "atripalda": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f863787f": [{
      "hkey": "fad8ae92",
      "slug": "via-morelli-e-silvati-viale-italia",
      "name": "Via Morelli e Silvati-Viale Italia",
      "primary": true,
      "skipSearch": false
    }],
    "baccanico": [{
      "hkey": "fad8ae92",
      "slug": "via-morelli-e-silvati-viale-italia",
      "name": "Via Morelli e Silvati-Viale Italia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "avellino"
    }],
    "8882bf27": [{
      "hkey": "e9cd10be",
      "slug": "mazzini-san-tommaso",
      "name": "Mazzini-San Tommaso",
      "primary": true,
      "skipSearch": false
    }],
    "c-da-san-tommaso": [{
      "hkey": "e9cd10be",
      "slug": "mazzini-san-tommaso",
      "name": "Mazzini-San Tommaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "35ec957f": [{
      "hkey": "c1dd2b5b",
      "slug": "contrada-archi",
      "name": "Contrada Archi",
      "primary": true,
      "skipSearch": false
    }],
    "cappuccini": [{
      "hkey": "c1dd2b5b",
      "slug": "contrada-archi",
      "name": "Contrada Archi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5f95c956": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "cento": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92b22ded": [{
      "hkey": "a83672b0",
      "slug": "emanuele-ii-piazza-liberta",
      "name": "Emanuele II-Piazza Libertà",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "a83672b0",
      "slug": "emanuele-ii-piazza-liberta",
      "name": "Emanuele II-Piazza Libertà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4560d2c1": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "lioni": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8b05bdc": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "mercogliano": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af66ab04": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "273b5f30": [{
      "hkey": "dde30ddf",
      "slug": "rione-ferrovia-pianodardine",
      "name": "Rione Ferrovia-Pianodardine",
      "primary": true,
      "skipSearch": false
    }],
    "pianodardine": [{
      "hkey": "dde30ddf",
      "slug": "rione-ferrovia-pianodardine",
      "name": "Rione Ferrovia-Pianodardine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4fb22051": [{
      "hkey": "e9cd10be",
      "slug": "mazzini-san-tommaso",
      "name": "Mazzini-San Tommaso",
      "primary": true,
      "skipSearch": false
    }],
    "q9": [{
      "hkey": "e9cd10be",
      "slug": "mazzini-san-tommaso",
      "name": "Mazzini-San Tommaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "avellino"
    }],
    "44e7fb71": [{
      "hkey": "e9cd10be",
      "slug": "mazzini-san-tommaso",
      "name": "Mazzini-San Tommaso",
      "primary": true,
      "skipSearch": false
    }],
    "rione-mazzini": [{
      "hkey": "e9cd10be",
      "slug": "mazzini-san-tommaso",
      "name": "Mazzini-San Tommaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "avellino"
    }],
    "12487fbd": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "s-biagio": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "603b89b0": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "sala-di-serino": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79fd1777": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele-di-serino": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3ffd7a01": [{
      "hkey": "7b8f536f",
      "slug": "a-annarumma-a-gasperi",
      "name": "A. Annarumma-A. Gasperi",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "7b8f536f",
      "slug": "a-annarumma-a-gasperi",
      "name": "A. Annarumma-A. Gasperi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "avellino"
    }],
    "468223f9": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "serino": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5ab31fa0": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "solofra": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67e95ed9": [{
      "hkey": "fad8ae92",
      "slug": "via-morelli-e-silvati-viale-italia",
      "name": "Via Morelli e Silvati-Viale Italia",
      "primary": true,
      "skipSearch": false
    }],
    "v-le-italia": [{
      "hkey": "fad8ae92",
      "slug": "via-morelli-e-silvati-viale-italia",
      "name": "Via Morelli e Silvati-Viale Italia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ea576574": [{
      "hkey": "f1c3e7b8",
      "slug": "valle-ponticelli",
      "name": "Valle-Ponticelli",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "f1c3e7b8",
      "slug": "valle-ponticelli",
      "name": "Valle-Ponticelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "avellino"
    }],
    "28b2d25d": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "via-piave": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7eba9d76": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "skipSearch": false
    }],
    "via-roma": [{
      "hkey": "148f4593",
      "slug": "avellino",
      "name": "Avellino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d01904bb": [{
      "hkey": "7b8f536f",
      "slug": "a-annarumma-a-gasperi",
      "name": "A. Annarumma-A. Gasperi",
      "primary": true,
      "skipSearch": false
    }],
    "via-tagliamento": [{
      "hkey": "7b8f536f",
      "slug": "a-annarumma-a-gasperi",
      "name": "A. Annarumma-A. Gasperi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;